import JsxHelper from '../../../Helpers/JsxHelper';
import EvaluatorItem from './EvaluatorItem';

export default class SchedulingExportItem extends EvaluatorItem {
  static Currency() {
    return 'USD';
  }

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = [
    'SassiePpacceptedOn',
    'TipaltiLastDataCheck',
    'EvBday',
    'EvLastShop',
    'EvInactive',
    'EvFraudGroupModifiedOn',
    'EvSignDate',
    'EvLastlogin',
  ];

  static BoolFields = [
    'Emailchanged',
    'EvInternational',
    'EvEmailoptout',
    'EvIsAgency',
    'EvVat',
    'EvVatexp',
    'EvPaymentOfficeOverride',
    'EvDdpverify',
    'TipaltiPayableStatus',
    'EvaluatorExtendedEvexVehicle',
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'First Name',
        orderById: 'EvFirstName',
        data: 'EvFirstName',
      },
      {
        label: 'Last Name',
        orderById: 'EvLastName',
        data: 'EvLastName',
      },
      { label: 'Email', orderById: 'EvEmail', data: (item) => JsxHelper.MailTo(item.EvEmail) },
      {
        label: 'Telephone 1',
        orderById: 'EvPhoneNumber1',
        data: 'EvPhoneNumber1',
      },
      {
        label: 'Telephone 2',
        orderById: 'EvPhoneNumber2',
        data: 'EvPhoneNumber2',
      },
      { label: 'Apollo Account Status', orderById: 'EvStatus', data: 'EvStatus', minWidth: '120px' },
      { label: 'DOB', orderById: 'EvBday', data: 'EvBday' },
      { label: 'City', orderById: 'EvCity', data: 'EvCity' },
      { label: 'State', orderById: 'EvState', data: 'EvState' },
      { label: 'ZIP', orderById: 'EvZipCode', data: 'EvZipCode' },
      { label: 'Country', orderById: 'EvCountry', data: 'CountryName' },
      { label: 'Rating (Last)', orderById: 'EvRating', data: 'CombinedRating' },
      { label: 'Signup Date', orderById: 'EvSignDate', data: 'EvSignDate' },
      { label: 'Last Login Date', orderById: 'EvLastlogin', data: 'EvLastlogin' },
      { label: 'Last Shop Date', orderById: 'EvLastShop', data: 'EvLastShop' },
      { label: 'All Shops In n Days #', orderById: 'AllShopsCountLastNDays', data: 'AllShopsCountLastNDays' },
      {
        label: 'Excluded Shops In n Days #',
        orderById: 'ExcludedShopsCountLastNDays',
        data: 'ExcludedShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Excluded PS In n Days #',
        orderById: 'ExcludedPSShopsCountLastNDays',
        data: 'ExcludedPSShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Finalized/Locked Shops In n Days #',
        orderById: 'FinalizedLockedShopsCountLastNDays',
        data: 'FinalizedLockedShopsCountLastNDays',
      },
    ];
  }
}
